<template>
  <v-timeline-item
    :color="time.Color"
    small
  >
    <v-row class="pt-1" style="margin-top: -15px;">
      <v-col cols="12">
        <strong style="font-size: 1.2rem;"
          :style="{ 'font-family': FontContent }"
        >{{time.Time}}</strong>
      </v-col>
      <v-col cols="12" style="margin-top:-20px">
        <strong style="font-size: 1rem;"
          :style="{ color: time.Color,
                'font-family': FontContent
                }"
        >{{title}}</strong>
        <div class="caption" style="font-size: 0.9rem !important;"
          :style="{ 'font-family': FontContent }"
        >{{description}}</div>
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

 <script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      time: {
        type: Object,
        required: true,
        default: null
      },
    },
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      title () {
        return utils.getTranslation (this.time.Title, this.locale)
      },
      description () {
        return utils.getTranslation (this.time.Description, this.locale)
      }
    }
  }
</script>

